import { render, staticRenderFns } from "./QuizDragAndDrop.vue?vue&type=template&id=208c7b14&"
import script from "./QuizDragAndDrop.vue?vue&type=script&lang=js&"
export * from "./QuizDragAndDrop.vue?vue&type=script&lang=js&"
import style0 from "./QuizDragAndDrop.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports